import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import { Link } from 'react-router-dom'
import SellerInboundUrlParamsTableCellService from './seller-inbound-url-params-table-cell-service'

const propTypes = {
  inbound              : PropTypes.object,
  to                   : PropTypes.func,
  onSelectRow          : PropTypes.func,
  sellerInboundColumns : PropTypes.array,
  sellerColumns        : PropTypes.array,
  curationColumns      : PropTypes.array,
  actionButtonText     : PropTypes.string
}

const defaultProps = {
  sellerInboundColumns : [],
  sellerColumns        : [],
  curationColumns      : [],
  actionButtonText     : 'Detail'
}

/**
 * Component to display each ::Seller::Inbound data in SellerInboundUrlParamsTable
 * @param {Object} inbound - Seller::Inbound
 * @param {String} to - link to redirect when user click action button
 * @param {Function} onSelectRow - function that trigger when user click action button
 * @param {Array} sellerInboundColumns - Array of displayed sellerInbounds column section
 * @param {Array} sellerColumns - Array of displayed seller column section
 * @param {Array} curationColumns - Array of displayed curation column section
 * @param {String} actionButtonText - Action button text/label
 */

const SellerInboundUrlParamsTableRow = ({
  inbound,
  to,
  onSelectRow,
  sellerInboundColumns,
  sellerColumns,
  curationColumns,
  actionButtonText
}) => {

  const inboundCellData = SellerInboundUrlParamsTableCellService.generateInboundCellData(inbound)

  const ActionButton = () => (
    <>
      {
        to && (
          <Button
            color='primary'
            tag={ Link }
            size='sm'
            to={ to(inbound.id) }
          >
            { actionButtonText }
          </Button>
        )
      }

      {
        onSelectRow && (
          <Button
            color='primary'
            size='sm'
            onClick={ () => onSelectRow(inbound) }
          >
            { actionButtonText }
          </Button>
        )
      }
    </>
  )

  return (
    <tr>
      {
        sellerInboundColumns.map((data) => (
          <td key={ `inbound-data-${inbound.id}-${data.name}` } style={ inboundCellData[data.name].style }>
            { inboundCellData[data.name].content }
            <br />
            {
              data.name === 'code' && (
                <ActionButton/>
              )
            }
          </td>
        ))
      }
      {
        curationColumns.map((data) => (
          <td key={ `inbound-data-${inbound.id}-${data.name}` } style={ inboundCellData[data.name].style }>
            { inboundCellData[data.name].content }
          </td>
        ))
      }
      {
        sellerColumns.map((data) => (
          <td key={ `inbound-data-${inbound.id}-${data.name}` } style={ inboundCellData[data.name].style }>
            { inboundCellData[data.name].content }
          </td>
        ))
      }
    </tr>
  )
}

SellerInboundUrlParamsTableRow.propTypes    = propTypes
SellerInboundUrlParamsTableRow.defaultProps = defaultProps

export default SellerInboundUrlParamsTableRow